import { render, staticRenderFns } from "./SatisKopyalaForm.vue?vue&type=template&id=9ffe308c"
import script from "./SatisKopyalaForm.vue?vue&type=script&lang=ts"
export * from "./SatisKopyalaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports